<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">
              <div class="col-12 justify-content-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn" v-if="hasPermission('SETTINGS_CAD_BUILDING_REFERENCE_REGRESSION_ADD')" @click="showBuildingFieldReferenceEditModal(null)">
                    {{$t("action.add")}}
                </button>
              </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>Код</th>
                      <th>Текст</th>
                      <th>Текст(ru)</th>
                      <th>Актив</th>
                      <th>Парент</th>
                      <th class="text-center">{{$t("realEstate.field.action")}}</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && references && references.data">
                  <tr v-for="reference in references.data" :key="reference.id">
                      <td>{{reference.code}}</td>
                      <td>{{reference.name}}</td>
                      <td>{{reference.nameRu}}</td>
                      <td>{{reference.active ? 'Ҳа' : 'Йўқ'}}</td>
                      <td>{{reference.parent ? reference.parent.name: ''}}</td>
                      <td class="td-actions text-center">
                          <button class="all-btn edit-btn table-action" data-original-title="Edit"
                                  @click="showBuildingFieldReferenceEditModal(reference)">
                              <i class="fa fa-edit"></i>
                          </button>
                      </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5"
                      v-if="!loading && references && references.data && references.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && references && references.total && references.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="references.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <BuildingFieldReferenceEditModal/>
    </div>
</template>

<script>

    import BuildingFieldReferenceEditModal from './BuildingFieldReferenceEditModal'
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';

    export default {
        components: {
            'b-pagination': bPagination,
            BuildingFieldReferenceEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                references: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('/building/field/reference/list', this.filter)
                    .then(res => {
                        this.references = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    })

            },
            showBuildingFieldReferenceEditModal(data) {
                this.$eventBus.$emit('showBuildingFieldReferenceEditModal', data);
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('buildFieldReferenceChanged', () => {
                this.initList();
            })
        }
    }
</script>

<style scoped>

</style>